// Minutes before the start of a PTU when it becomes non-editable

import type { DateTime } from 'luxon'

import { BidType, MarketProgram } from '@/features/bidding/constants'

// According to requirement: "We will stop bidding for a PTU at QH-50"
const PTU_EXPIRATION_MINUTES = 50

/**
 * Determines if a PTU is editable based on its start time and bid type
 * For mFRR Energy bids: A PTU is editable if it's at least PTU_EXPIRATION_MINUTES (50) minutes in the future
 * For all other bid types: All PTUs are considered editable
 */
export function isPtuEditable(
  currentTime: DateTime,
  ptuStart: DateTime,
  bidType: BidType,
  marketProgram?: MarketProgram,
): boolean {
  // Check if this is an Energy bid for mFRR market programs
  const isMfrrEnergy =
    bidType === BidType.ENERGY && (marketProgram === MarketProgram.MFRR_UP || marketProgram === MarketProgram.MFRR_DOWN)

  // If not an Energy bid for mFRR, all PTUs are considered editable
  if (!isMfrrEnergy) {
    return true
  }

  const expirationThreshold = currentTime.plus({ minutes: PTU_EXPIRATION_MINUTES })

  return ptuStart >= expirationThreshold
}
